import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BulbOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { Trans } from "@devowl-wp/react-frontend";
import { useTranslation } from "../../../../../../others/i18n.js";
function WhenOnOfTip() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(Popover, {
        placement: "right",
        content: /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs(Trans, {
                children: [
                    "There are currently the following prefixes available:",
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("code", {
                        children: "is-wordpress-plugin-or-theme-active"
                    })
                ]
            })
        }),
        title: t("Examples"),
        children: /*#__PURE__*/ _jsx(Button, {
            type: "link",
            icon: /*#__PURE__*/ _jsx(BulbOutlined, {}),
            children: t("Prefixes")
        })
    });
}
export { WhenOnOfTip };
